// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"297":"7c81d37e","379":"d319d75a","404":"77061d53","439":"3741e727","496":"49ae1404"}[chunkId] + ".chunk.js";
};